import type { ProductCard } from '@/storefront/components/ProductCard'
import type { ComponentProps } from 'react'

export type ProductCardListingUx = Pick<
  ComponentProps<typeof ProductCard>,
  'showVariantSwatches' | 'showStockIndicator' | 'merchBadges' | 'imageHover'
>

/**
 * Single resolver for listing Ux flags (matches product-grid / blockCatalog defaults).
 * Blocks with editor props pass partial overrides.
 */
export function resolveProductCardListingUx(overrides?: Partial<ProductCardListingUx>): ProductCardListingUx {
  return {
    showVariantSwatches: overrides?.showVariantSwatches === true,
    showStockIndicator: overrides?.showStockIndicator !== false,
    merchBadges: overrides?.merchBadges !== false,
    imageHover: overrides?.imageHover !== false,
  }
}
